import React, { useEffect } from 'react';
import PageContainer from '../PageContainer';
import { RouteComponentProps, useParams } from 'react-router';
import { EventFormType } from '../../types/events';
import { NoticeFormType } from '../../types/notices';
import {
  ActionPlan,
  ActionReport,
  EventInvite,
  GeneralExpenseReport,
  MeetingMinutes,
  TravelExpenseReport,
} from '../forms';
import { useKennoTenant } from '../../context/kennoTenantContext';
import { loadOwnForms } from '../../context/kennoTenantActions';
import { ExpenseReportFormType } from '../../types/expense-reports';
import { Form } from '../../types/forms';

const UpdateFormPage = ({ history }: RouteComponentProps) => {
  const { id: formId } = useParams<{ id?: string }>();
  const [{ ownForms }, dispatch] = useKennoTenant();

  useEffect(() => {
    loadOwnForms(dispatch);
  }, [dispatch]);

  const form = ownForms.data?.find((form) => form.id === formId);

  if (!form) return <></>;

  const renderForm = (form: Form) => {
    switch (form.formType) {
      case EventFormType.EventInvite:
        return <EventInvite updateForm={form} />;
      case NoticeFormType.ActionPlan:
        return <ActionPlan updateForm={form} />;
      case NoticeFormType.ActionReport:
        return <ActionReport updateForm={form} />;
      case NoticeFormType.MeetingMinutes:
        return <MeetingMinutes updateForm={form} />;
      case ExpenseReportFormType.GeneralExpenseReport:
        return <GeneralExpenseReport updateForm={form} />;
      case ExpenseReportFormType.TravelExpenseReport:
        return <TravelExpenseReport updateForm={form} />;
    }
  };

  return <PageContainer history={history}>{renderForm(form)}</PageContainer>;
};

export default UpdateFormPage;
